console.log(`Amplif Events: front module loaded.`)
